export const makeid = (length: number) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < length; i++) {
        result += characters.charAt(i % characters.length);
    }
    return result;
}

export function xmlSanitize(input: string) {
    if (!input)
        return input;

    return input.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');

}

export function saveDownload(name: any, data: any, type: any, isBinary: any) {
    if (isBinary) {
        var bytes = new Array(data.length);
        for (var i = 0; i < data.length; i++) {
            bytes[i] = data.charCodeAt(i);
        }
        data = new Uint8Array(bytes);
    }

    var blob = new Blob([data], { type: type });
    let objectURL = window.URL.createObjectURL(blob);
    let anchor = document.createElement('a');

    anchor.href = objectURL;
    anchor.download = name;
    anchor.click();

    URL.revokeObjectURL(objectURL);
}

export const b64toByteArray = (b64Data: any, byteArrays: any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return byteArrays;

}

export const arrayBufferToBase64 = async (blob: Blob) => {
    const _ = new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (evt) {
            if (evt?.target?.result) {
                const data = evt.target.result as string;

                resolve(data.substr(data.indexOf(',') + 1));
            }
        };
        reader.readAsDataURL(blob);
    });
    return _;
}

export function parseURL() {
    return Object.fromEntries(new URLSearchParams(window.location.search));
}

export function trimGUID(guid: string) {
    return guid.replace(/[{}]/g, '');
}


export function trimGUIDLower(guid: string) {
    return guid.replace(/[{}]/g, '').toLowerCase();
}

//TODO: idk whats causing extra / sometimes its there, sometimes its not, until we find a fix
export function cleanRoute(path: string) {
    return path.replace(/\/$/i, '');
}


export const updateArrayMerge = (array: any[], oldItem: any, newItemChanges: any) => {
    var index = array.indexOf(oldItem);
    if (index === -1)
        return array;

    return [
        ...array.slice(0, index),
        Object.assign({}, array[index], newItemChanges),
        ...array.slice(index + 1)
    ];
}

export function updateArrayReplace<T>(array: T[], oldItem: T, newItemChanges: T) {
    var index = array.indexOf(oldItem);
    if (index === -1)
        return array;

    return [
        ...array.slice(0, index),
        Object.assign({}, newItemChanges),
        ...array.slice(index + 1)
    ];
}

export function removeItem<T>(arr: Array<T>, value: T): Array<T> {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}

export function hash32Int(input: string) {
    var hash = 0, i, chr;
    if (input.length === 0) return hash;
    for (i = 0; i < input.length; i++) {
        chr = input.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

export function hashObjectKeys(object: any) {
    const keys = Object.keys(object).sort().join(',');
    return hash32Int(keys);
}

/**
 * Deprecated
 * @param object 
 * @returns 
 */
export function jsonClone<T>(object: T) {
    return JSON.parse(JSON.stringify(object)) as T;
}

export function copyPropertiesOnly<T>(
    source: T,
    destination: T,
    properties: (keyof T)[],
    clone: boolean,
    predicate?: (key: (keyof T), source: T) => boolean
) {

    properties.forEach(eachKey => {

        if (predicate)
            if (!predicate(eachKey, source))
                return;

        if (source[eachKey] !== undefined)
            if (clone)
                destination[eachKey] = structuredClone(source[eachKey]);
            else
                destination[eachKey] = source[eachKey];
        else
            console.warn('Copy - property undefined', eachKey);
    });

    return destination;
}

export function copyPropertiesExcept<T extends {}>(
    source: T,
    destination: T,
    properties: (keyof T)[],
    predicate?: (key: (keyof T), source: T) => boolean) {

    for (const [key, value] of Object.entries(source) as any) {
        if (predicate)
            if (!predicate(key, source))
                return;

        if (properties.indexOf(key))
            return;

        destination[key as keyof T] = value;
    }

    return destination;
}

export function Delay(duration: number) {
    return new Promise<null>((resolve, reject) => {
        setTimeout(() => {
            resolve(null);
        }, duration);
    })
}

export function timestamp() {
    return new Date().getTime().toString(36).toUpperCase();
}

// https://stackoverflow.com/questions/16229494/converting-excel-date-serial-number-to-date-using-javascript
export function ExcelDateToJSDate(serial: number) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
}

/**
 * 
 * @param date 
 * @param format 
 * @returns 
 * en-US-ET : string, converted to Eastern time zone.   
 * en-US-ET:yyyy-MM-ddThh:mm:ssZ string, ignoring the timezone and assume the its a local date  
 * iso : string of date in iso/utc  
 * local:yyyy-MM-dd : string of date in yyyy-MM-dd format local to user's timezone  
 * local:MM/dd/yyyy : string of date in MM/dd/yyyy format local to user's timezone
 */
export function formatDate(date: Date, format: 'en-US-ET' | 'local:yyyy-MM-dd' | 'local:MM/dd/yyyy' | 'local:yyyy-MM-ddT00:00:00Z' | 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local') {
    // TODO switch statement
    switch (format) {
        case 'en-US-ET': {
            return date.toLocaleString('en-US', {
                month: '2-digit',
                year: 'numeric',
                day: '2-digit',
                timeZone: 'America/New_York',
            });
        }

        case "en-US-ET:yyyy-MM-ddThh:mm:ssZ as local": {

            // removing the Z part, so it would be assumed as local time
            const _date = new Date(`${date.toISOString()?.split('T')[0]}T00:00:00`);
            return _date.toLocaleString('en-US', {
                month: '2-digit',
                year: 'numeric',
                day: '2-digit',
                timeZone: 'America/New_York',
            });
        }

        case "local:yyyy-MM-dd": {
            // Better Solution:
            // https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
            // const offset = yourDate.getTimezoneOffset()
            // yourDate = new Date(yourDate.getTime() - (offset*60*1000))
            // return yourDate.toISOString().split('T')[0]

            let month = '' + (date.getMonth() + 1);
            let day = '' + date.getDate();
            const year = date.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }

        case "local:yyyy-MM-ddT00:00:00Z": {
            // Better Solution:
            // https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
            // const offset = yourDate.getTimezoneOffset()
            // yourDate = new Date(yourDate.getTime() - (offset*60*1000))
            // return yourDate.toISOString().split('T')[0]

            let month = '' + (date.getMonth() + 1);
            let day = '' + date.getDate();
            const year = date.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-') + 'T00:00:00Z';
        }

        case "local:MM/dd/yyyy": {
            let month = '' + (date.getMonth() + 1);
            let day = '' + date.getDate();
            const year = date.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [month, day, year].join('/');
        }

        default:
            throw new Error('format unknown');
    }


}

/**
 * 
 * @param date 
 * @param inputFormat 
 * @returns 
 * iso : JSDate from iso string
 * local:yyyy-MM-dd : JSDate from yyyy-MM-dd, ignore timezone associated with the date and only use date
 * *adding T00:00:00 without timezone or UTC indicator, iso like format, makes browser generate time for beginning of day in user's timezone
 * 
 * new Date('2020-11-10T00:00:00')
 * Tue Nov 10 2020 00:00:00 GMT-0800 (Pacific Standard Time)
 */
export function parseDate(date: string, inputFormat: 'local:yyyy-MM-dd' | 'yyyy-MM-ddThh:mm:ssZ as local' | 'iso') {
    switch (inputFormat) {
        case "iso":
            return new Date(date);
        case "local:yyyy-MM-dd":
            return new Date(`${date?.split('T')[0]}T00:00:00`);
        case "yyyy-MM-ddThh:mm:ssZ as local":
            return new Date(`${date?.split('T')[0]}T00:00:00`);
        default:
            throw new Error('format unknown');
    }
}

export function addNMonthsToDateString(date: string, n: number): string {
    const currentDate = parseDate(date, 'local:yyyy-MM-dd');

    // in case JS does not calc month beyond 12
    // if (currentDate.getUTCMonth() + n > 11) {
    //     currentDate.setUTCFullYear(currentDate.getUTCFullYear() + Math.floor(n / 11));
    //     n = n % 11;
    // }

    // datetime savings causes November to shfit
    currentDate.setUTCHours(currentDate.getUTCHours() + 2);

    currentDate.setUTCMonth(currentDate.getUTCMonth() + n);
    currentDate.setUTCDate(currentDate.getUTCDate() - 1);
    return formatDate(currentDate, 'local:yyyy-MM-dd')
};


export function strEncodeUTF16(str: string) {
    var buf = new ArrayBuffer(str.length * 2);
    var bufView = new Uint16Array(buf);
    for (var i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return bufView;
}


export type TGroupBy<T> = (keyof T)[] | ((row: T) => string);
export type TGroupByAggregateMethod<T> = ((prevValue: T[keyof T], currValue: T[keyof T], key: keyof T, row: T) => T[keyof T]);
export type TGroupByAggregate<T> = {
    [K in keyof T]?: TGroupByAggregateMethod<T>;
}
export type TGroupByResult<T> = {
    key: string,
    group: string[],
    data: T[],
    aggregate?: T
}

export function groupByWithAggregateFlat<T>(rows: T[], groupBy: TGroupBy<T>, aggregate?: TGroupByAggregate<T>) {

    const groupByRows = [] as T[][];
    const groupList = {} as Record<string, T[]>;

    const groupByArray = groupBy instanceof Array ? groupBy : null;
    const groupByFunction = typeof groupBy === 'function' ? groupBy : null;

    const stats = [] as TGroupByResult<T>[];

    rows.forEach(eachRow => {
        let groupKey = ''

        let groupKeyArray: any[] = []
        if (groupByArray)
            groupByArray.forEach((eachGroup) => {
                const key = eachRow[eachGroup];
                groupKeyArray.push(key);
                groupKey += '>' + key ?? '?';
            })
        else if (groupByFunction) {
            groupKey = groupByFunction(eachRow);
        }

        let subArray: T[] = [];
        const groupId = groupList[groupKey];

        if (!groupId) {
            groupList[groupKey] = subArray;
            groupByRows.push(subArray);
            stats.push({
                key: groupKey,
                group: groupKeyArray, data: []
            })
        } else {
            subArray = groupList[groupKey];
        }

        subArray.push(eachRow)
    });

    stats.forEach((q, index) => { q.data = groupByRows[index] });

    // TODO maybe optimized, by merging with above
    if (aggregate)
        groupByRows.forEach((eachGroup, index) => {
            const aggObject = {} as T

            const aggregateKeyValues = Object.entries(aggregate) as [keyof T, TGroupByAggregateMethod<T>][];

            for (const [aggKey, aggMethod] of aggregateKeyValues) {
                eachGroup.reduce((prev, curr) => {
                    const previousValue = prev[aggKey];
                    //@ts-ignore
                    const currentValue = curr[aggKey];
                    const value = aggMethod(previousValue, currentValue, aggKey, curr);
                    prev[aggKey] = value;
                    return prev;
                }, aggObject);
            }

            stats[index].aggregate = aggObject;
        });

    return stats;
}

export interface IReturn<T> {
    rows?: T[];
    grouping?: Record<string, IReturn<T>>;
    rowsAggregate?: T
}



export function groupByWithAggregate<T>(rows: T[], groupBy: TGroupBy<T>, aggregate?: TGroupByAggregate<T>, aggregateLeaves?: boolean) {

    const groupByKeys = groupBy as (keyof T)[];

    const groupByNested = (row: T, groupByDepth: number, initialObject: IReturn<T>) => {

        if (!initialObject.rows)
            initialObject.rows = [];

        initialObject.rows.push(row);

        // ex: category
        const groupByKey = groupByKeys[groupByDepth];

        if (!groupByKey)
            return;

        //@ts-ignore
        const groupByValue = row[groupByKey] as string;

        let subGroup = {} as IReturn<T>;

        if (!initialObject.grouping)
            initialObject.grouping = {};

        if (initialObject.grouping[groupByValue])
            subGroup = initialObject.grouping[groupByValue]
        else
            initialObject.grouping[groupByValue] = subGroup;

        if (groupByDepth < groupByKeys?.length)
            groupByNested(row, groupByDepth + 1, subGroup);
    }

    const returnObject: IReturn<T> = { rows: [], grouping: {} };

    rows.forEach(eachRow => {
        groupByNested(eachRow, 0, returnObject);
    });

    const aggregateForMe = (par: IReturn<T>) => {
        if (par.grouping) {
            for (const [key, value] of Object.entries(par.grouping)) {
                aggregateForMe(value);
            }

            // only doing node ends
            if (aggregateLeaves)
                return;
        }

        if (par.rows && par.rows.length > 0) {
            const aggObject = {} as T;

            //@ts-ignore
            const aggregateKeyValues = Object.entries(aggregate) as [keyof T, TGroupByAggregateMethod<T>][];

            for (const [aggKey, aggMethod] of aggregateKeyValues) {
                par.rows.reduce((prev, curr) => {
                    const previousValue = prev[aggKey];
                    //@ts-ignore
                    const currentValue = curr[aggKey];
                    const value = aggMethod(previousValue, currentValue, aggKey, curr);

                    prev[aggKey] = value;
                    return prev;

                }, aggObject);
            }

            par.rowsAggregate = aggObject;
        }
    }
    aggregateForMe(returnObject);

    return returnObject;
}

export function dateFromOADate(oaDate: number) {
    // Treat integer part is whole days
    var days = oaDate >> 0;

    // Treat decimal part as part of 24hr day, always +ve
    var ms = Math.abs((oaDate - days) * 8.64e7);
    // Add days and add ms
    return new Date(1899, 11, 30 + days, 0, 0, 0, ms);
}

export function hasValue(object: any) {
    if (object === undefined)
        return false;

    if (object === null)
        return false;

    return true;
}



export function objectFlip(obj: any) {
    const ret = {} as any;
    if (!obj)
        return null
    Object.keys(obj).forEach(key => {
        ret[obj[key].value] = obj[key].name;
    });
    return ret;
}


export function ArrayToLookup<T extends { id: string }>(object: T[]) {
    const map = object.reduce((prev, curr) => {
        prev[curr.id] = curr;
        return prev;
    }, {} as Record<string, T>);

    return map;
}

export function ArrayToMap<T extends { id: string }>(object: T[]) {
    const map = new Map<string, T>();
    object.forEach(e => {
        map.set(e.id, e);
    });

    return map;
}


export function ArrayToLookupByKey<T extends Record<string, any>>(object: T[], indexer: keyof T) {
    const map = object.reduce((prev, curr) => {
        const key = curr[indexer];
        prev[key] = curr;
        return prev;
    }, {} as Record<string, T>);

    return map;
}

export function ArrayToMapByKey<T extends { id: string }>(object: T[], indexer: keyof T) {
    const map = new Map<string, T>();

    object.forEach(e => {
        const key = (e[indexer] as unknown) as string;
        map.set(key, e);
    });

    return map;
}

export function ArrayToLookupByPredicate<T extends Record<string, any>>(object: T[], predicate: (item: T) => string) {
    const map = object.reduce((prev, curr) => {
        const key = predicate(curr);
        prev[key] = curr;
        return prev;
    }, {} as Record<string, T>);

    return map;
}

// TODO bad naming, predicate is filter, instead of filder use predicate and instead of predicate use keySelector
export function ArrayToLookupByPredicateWithMap<T extends Record<string, any>, K extends {}>(
    items: T[],
    itemToKey: (item: T) => string,
    project: (item: T, currentIndex?: number) => K,
    predicate?: (item: T) => boolean,
    action?: (item: K, currentIndex?: number) => void
) {
    const map = items.reduce((prev, curr, currentIndex) => {

        if (predicate && !predicate(curr))
            return prev;

        const key = itemToKey(curr);
        const u = project(curr, currentIndex);
        action?.(u, currentIndex);
        prev[key] = u;
        return prev;
    }, {} as Record<string, K>);

    return map;
}

export function ArrayToArrayLookupByPredicate<T extends Record<string, any>>(object: T[], predicate: (item: T) => string) {
    const map = object.reduce((prev, curr) => {
        const key = predicate(curr);
        const source = prev[key] ?? [];
        source.push(curr);
        prev[key] = source;
        return prev;
    }, {} as Record<string, T[]>);

    return map;
}

export function ArrayToArrayByPredicateFlat<T extends Record<string, any>>(object: T[], predicate: (item: T) => string) {
    const obj = ArrayToArrayLookupByPredicate(object, predicate);
    var arr: T[][] = [];
    for (var i in obj) {
        arr.push(obj[i]);
    }
    return arr;
}


export function ArrayToMapByPredicate<T extends Record<string, any>>(
    object: T[],
    predicate: (item: T) => string
) {
    const map = new Map<string, T>();
    object.forEach(e => {
        const key = predicate(e)
        map.set(key, e);
    });

    return map;
}

export function ArrayToMapByPredicateWithMap<T extends Record<string, any>, K extends {}>(
    object: T[],
    predicate: (item: T) => string,
    mapper: (item: T, index: number) => K
) {
    const map = new Map<string, K>();
    object.forEach((eachObject, index) => {
        const key = predicate(eachObject)
        map.set(key, mapper(eachObject, index));
    });

    return map;
}

// TODO make fn args type-safe
// https://stackoverflow.com/questions/62233382/how-do-i-define-and-call-a-generic-function-parameter-in-typescript
// type Parameter<T> = T extends (arg: infer T) => any ? T : never;
// function call<F extends (arg: any) => any>(f: F, arg: Parameter<F>): ReturnType<F> {
//   return f(arg);
// }
export function MemoizeAsync<T>(fn: () => Promise<T>) {
    let cache: T | null = null;

    return async () => {
        if (cache)
            return cache;

        cache = await fn();
        return cache;
    }
}

type TMemoizePar<T, U extends []> = (...par: U[]) => T;

export function Memoize<T, U extends []>(fn: TMemoizePar<T, U>) {
    let cache: T | null = null;

    return (...par: U[]) => {
        if (cache)
            return cache;

        cache = fn.apply(null, par);
        return cache;
    }
}

export function Compare<T>(source: T, target: T, includes?: (keyof T)[]) {
    let ret: Partial<T> = {};

    const propertiesAll = [
        ...Object.getOwnPropertyNames(source),
        ...Object.getOwnPropertyNames(target)
    ] as (keyof T)[];

    const properties = propertiesAll.filter((eachProperty, pos, list) => {

        if (includes && includes.indexOf(eachProperty) < 0)
            return false;

        if (list.indexOf(eachProperty) !== pos)
            return false;

        return true;
    });

    properties.forEach(eachProperty => {
        if (source[eachProperty] !== target[eachProperty]) {
            ret[eachProperty] = target[eachProperty];
        }
    });

    return ret;
}

export function DateToYYYYMMDDHHMMSS(date: Date) {
    return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours()).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2)
}

export function Acronym(string: string) {
    return string.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')
}


export function ArrayToGroupBy<T>(rows: T[]) {

}


export const cyrb53 = (str: string, seed = 0) => {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};


function wait(milliseconds: number) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

interface IWithTimeoutOptions {
    timeOut?: number;
    errorMessage?: string;
}

export function withTimeout<T>(promiseFn: (...args: any[]) => Promise<T>, opts: IWithTimeoutOptions) {
    const timeOut = opts?.timeOut ?? 2500;

    const errorMessage =
        opts?.errorMessage ?? `Your Request timed out after ${timeOut}ms`;

    return (...args: any[]) =>
        Promise.race([
            promiseFn(...args),
            wait(timeOut).then(() => {
                throw new Error(errorMessage);
            }),
        ]);
}


export function Transpose() {


    // adding a marker column
    const rowName = (eachRow: Record<string, any>) => {
        return eachRow.name;
    }

    // list of all valid keys
    const rowKeys = (rows: Record<string, any>[]) => {
        // first row should have all the data
        // Object.keys(rows[0]);

        const keys = {} as Record<string, string>;
        rows.forEach(row => {
            Object.keys(row).forEach(key => {
                keys[key] = key;
            })
        })

        return Object.keys(keys);
    }


    const testRows: Record<string, string>[] = [
        { name: 'benefit1', field1: "1x1", field2: "2x1", field3: "3x1" },
        { name: 'benefit2', field1: "1x2", field2: "2x2", field3: "3x2" },
        { name: 'benefit3', field1: "1x3", field2: "2x3", field3: "3x3", field4: 'wooho' },
        { name: 'benefit4', field1: "1x4", field2: "2x4", field3: "3x4" },
        { name: 'benefit5', field1: "1x5", field2: "2x5", field3: "3x5" },
    ];

    const newKeys = rowKeys(testRows);

    const newRows = newKeys.map(rKey => {
        const newRow = {} as Record<string, string>;

        testRows.forEach((row, ix) => {
            const name = rowName(row);
            newRow[name] = testRows[ix][rKey]
        });

        return newRow;
    })

    return { newKeys, newRows }

}


export function ExpressionToExpressionTree(expression: string) {
    const parseExpression = (expression: string) => {
        // Implement expression parsing logic here
        // Return the expression tree

        // Split the expression into individual tokens
        const tokens = expression.split(/(\(|\)|&|\|)/).filter(token => token.trim() !== '');

        // Define a helper function to check if a token is an operator
        const isOperator = (token: string) => token === '&' || token === '|';

        // Define a helper function to check if a token is a parenthesis
        const isParenthesis = (token: string) => token === '(' || token === ')';

        // Define a helper function to convert a token to a node in the expression tree
        const createNode = (token: string) => {
            if (isOperator(token)) {
                return {
                    type: 'operator',
                    value: token
                };
            } else {
                return {
                    type: 'operand',
                    value: token
                };
            }
        };

        // Define a helper function to build the expression tree recursively
        const buildExpressionTree = (tokens: string[]): any => {
            const stack = [];
            let i = 0;

            while (i < tokens.length) {
                const token = tokens[i];

                if (isParenthesis(token)) {
                    if (token === '(') {
                        const subExpressionTokens = [];
                        let openParenthesisCount = 1;
                        i++;

                        while (i < tokens.length && openParenthesisCount > 0) {
                            const subToken = tokens[i];

                            if (subToken === '(') {
                                openParenthesisCount++;
                            } else if (subToken === ')') {
                                openParenthesisCount--;
                            }

                            if (openParenthesisCount > 0) {
                                subExpressionTokens.push(subToken);
                            }

                            i++;
                        }

                        const subExpressionTree = buildExpressionTree(subExpressionTokens);
                        stack.push(subExpressionTree);
                    }
                } else {
                    const node = createNode(token);
                    stack.push(node);
                }

                i++;
            }

            return stack;
        };

        // Build the expression tree
        const expressionTree = buildExpressionTree(tokens);

        // Return the expression tree
        return expressionTree;
    }

    return parseExpression(expression);
}

export async function ScrollToPosition(container: HTMLElement | Window | any, position: number) {

    position = Math.round(position);

    if (container.scrollTop === position) {
        return;
    }

    let resolveFn: (value?: unknown) => void;
    let scrollListener: () => void;
    let timeoutId: NodeJS.Timeout;

    const promise = new Promise(resolve => {
        resolveFn = resolve;
    });

    const finished = () => {
        container.removeEventListener('scroll', scrollListener);
        resolveFn();
    };

    scrollListener = () => {
        clearTimeout(timeoutId);

        // scroll is finished when either the position has been reached, or 100ms have elapsed since the last scroll event
        if (container.scrollTop === position) {
            finished();
        } else {
            timeoutId = setTimeout(finished, 200);
        }
    };

    container.addEventListener('scroll', scrollListener);

    container.scrollTo({
        top: position,
        behavior: 'smooth',
    });

    return promise;
}

export const ScrollToPositionCascaded = async (elements: string[]) => {

    for (let index = 0; index < elements.length; index++) {
        const elementX = elements[index];

        const element = document.getElementById(elementX);

        const header = (element?.firstElementChild as HTMLElement);

        if (header.getAttribute("data-collapsed") === "true") {
            header?.click();
            await Delay(250);
        }
    }

    const lastElement = elements[elements.length - 1];

    {
        const element = document.getElementById(lastElement);
        if (element) {

            const offset = 100; // Adjust this value as needed
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            await ScrollToPosition(window, offsetPosition);
        }
    }


}


type TObjectRecord = Record<string, unknown>;

const isObjectRecord = (value: unknown): value is TObjectRecord => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const RecursiveMerge = <T extends TObjectRecord>(target: T, source: unknown): T => {
    if (!isObjectRecord(source)) {
        return target;
    }

    const targetRecord = target as TObjectRecord;

    for (const key of Object.keys(source)) {
        const sourceValue = source[key];

        if (isObjectRecord(sourceValue)) {
            const targetValue = targetRecord[key];
            if (!isObjectRecord(targetValue)) {
                targetRecord[key] = {};
            }

            RecursiveMerge(targetRecord[key] as TObjectRecord, sourceValue);
            continue;
        }

        targetRecord[key] = sourceValue;
    }

    return target;
};

export const DeepMerge = <T extends TObjectRecord>(target: T, source: unknown): T => {
    const result: TObjectRecord = { ...target };

    if (!isObjectRecord(source)) {
        return result as T;
    }

    for (const key of Object.keys(source)) {
        const sourceValue = source[key];

        if (isObjectRecord(sourceValue)) {
            const targetValue = result[key];
            result[key] = DeepMerge(
                isObjectRecord(targetValue) ? targetValue : {},
                sourceValue,
            );
            continue;
        }

        result[key] = sourceValue;
    }

    return result as T;
};


// chains methods, with delay between each method execution
export const ChainWithSchedule = (delay: number, ...fns: Array<() => void>) => {
    fns.forEach((fn, index) => {
        setTimeout(() => fn(), index * delay);
    });
};

export const BuildHighlightedText = (origin: string, target: string) => {
    if (origin === target) {
        return {
            originPrefix: origin,
            originDiff: '',
            originSuffix: '',
            targetPrefix: target,
            targetDiff: '',
            targetSuffix: '',
        };
    }

    let prefixLength = 0;
    const maxPrefixLength = Math.min(origin.length, target.length);

    while (prefixLength < maxPrefixLength && origin[prefixLength] === target[prefixLength]) {
        prefixLength += 1;
    }

    let suffixLength = 0;
    const maxSuffixLength = Math.min(origin.length - prefixLength, target.length - prefixLength);

    while (
        suffixLength < maxSuffixLength &&
        origin[origin.length - 1 - suffixLength] === target[target.length - 1 - suffixLength]
    ) {
        suffixLength += 1;
    }

    const originPrefix = origin.slice(0, prefixLength);
    const originDiff = origin.slice(prefixLength, origin.length - suffixLength);
    const originSuffix = origin.slice(origin.length - suffixLength);

    const targetPrefix = target.slice(0, prefixLength);
    const targetDiff = target.slice(prefixLength, target.length - suffixLength);
    const targetSuffix = target.slice(target.length - suffixLength);

    return {
        originPrefix,
        originDiff,
        originSuffix,
        targetPrefix,
        targetDiff,
        targetSuffix,
    };
};